import React, { useContext, lazy } from 'react';
import PropTypes from 'prop-types';
import { Separator, Stack } from '@fluentui/react';
import { perfMarkerPropTypes } from '@bingads-webui/performance-marker';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { I18nContext } from '@bingads-webui-react/i18n-context';
// import { StyledMatchReportPage, StyledFeedStatusPage } from '@bingads-webui-campaign-react/hotel-center-page';
import { ReportsV4SummaryBarWithOnlyName } from './summary-bar';
import { getStyles } from '../style';

const StyledMatchReport = lazy(async () => {
  const { StyledMatchReportPage } = await import(/* webpackChunkName: "styled-match-report-page" */'@bingads-webui-campaign-react/hotel-center-page');
  return { default: StyledMatchReportPage };
});
const StyledFeedStatus = lazy(async () => {
  const { StyledFeedStatusPage } = await import(/* webpackChunkName: "styled-feed-status-report-page" */'@bingads-webui-campaign-react/hotel-center-page');
  return { default: StyledFeedStatusPage };
});

export function PreviewPageImplForLegacy(props) {
  const i18n = useContext(I18nContext);
  const { perfMarker } = props;
  const reportName = i18n.getString(props.reportName);
  const classes = useDefaultStyles(getStyles);

  function renderHeader() {
    return (
      <Stack className={`header ${classes.reportPreviewHeader}`} horizontal>
        <Stack.Item>
          <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 15 }} className="name-container">
            <span id="ReportName" className="name">{reportName}</span>
          </Stack>
        </Stack.Item >
      </Stack>
    );
  }
  const renderBody = () => {
    switch (props.reportName) {
      case 'Matching':
        return <StyledMatchReport perfMarker={perfMarker} />;
      case 'Price feed status':
        return <StyledFeedStatus perfMarker={perfMarker} />;
      default:
        return null;
    }
  };
  return (
    <div className={`${classes.reportPreviewContainer} report-preview-container`}>
      <React.Fragment>
        <ReportsV4SummaryBarWithOnlyName
          reportName={reportName}
        />
        <div className="content-wrapper">
          <div className="main-view">
            {renderHeader()}
            <Separator className="seperator-view" />
            {renderBody()}
          </div>
        </div>
      </React.Fragment>
    </div>
  );
}

PreviewPageImplForLegacy.propTypes = {
  reportName: PropTypes.string.isRequired,
  perfMarker: perfMarkerPropTypes.isRequired,
};
